import React, { Suspense, useEffect, memo, useMemo } from "react";
import config from "./moduleMap";
import loadable from "@loadable/component";
import { ErrorBoundary } from "react-error-boundary";
import logger from "./logger";
import Modules from "./modules";
import ModuleLoader from "./components/ModuleLoader";

const loadableCache: Record<string, any> = {};
function getLoadableComponent(moduleMap: string) {
  if (!loadableCache[moduleMap]) {
    loadableCache[moduleMap] = loadable(() => import(`./modules/${moduleMap}`), { ssr: true });
  }
  return loadableCache[moduleMap];
}

function WrapperModule(props) {
    let { siteConfig, pagedata, moduleCount, browserDetails, pathName } = props
  useEffect(() => {
    import("./helpers").then(({ handleUserLogInState }) => {
      handleUserLogInState();
    });
  }, [pagedata])

  const WatchNewModules = memo(
    function _WatchModules() {
      // A preview payload already carries every module, and paginating would
      // fetch the published page's modules instead.
      if (typeof window !== "undefined" && window.isPreview) return null;
      return moduleCount > 4 ? (
        <Modules
          siteConfig={siteConfig}
          pagedata={pagedata}
          offset={4}
          moduleCount={moduleCount}
        />
      ) : null;
    },
    (prevProps, nextProps) => prevProps["pathName"] === nextProps["pathName"]
  );

  const modules = useMemo(() => {
    return pagedata?.map((module, index) => {
      const moduleMap = module?.layout?.view ? config.map[module.layout.view] : null;
      if (!moduleMap) {
        return logger(`Module not found for '${moduleMap}'`, "warn")
      }
      const Component = getLoadableComponent(moduleMap);
      return (
        <div key={`${pathName}-${module.id}`}>
          <ErrorBoundary fallback={<p>Something went wrong</p>}>
            <Suspense fallback={null}>
              <Component
                browserDetails={browserDetails}
                siteConfig={siteConfig}
                moduleData={module}
                isFirstModule={index === 0}
              />
            </Suspense>
          </ErrorBoundary>
        </div>
      );
    });
  }, [pagedata, browserDetails, siteConfig]);

  return (
    <>
      <ModuleLoader />
      {modules}
      {<WatchNewModules
        {...props}
      />}
    </>
  );
}

export default memo(WrapperModule, (prevProps, nextProps) => {
  return prevProps.pagedata === nextProps.pagedata;
});
